import { Button } from "@blueprintjs/core";
import { type PropsWithChildren, useMemo, useState } from "react";
import { useItemGridFilterContext } from "./context-item-grid-filter";
import "./ItemGridFilter.css";

export type ItemGridFilterProps = PropsWithChildren<{
  onClickFilterReset: () => void;
  property: string;
  text: string;
}>;

export function ItemGridFilter({
  onClickFilterReset,
  property,
  text,
  children,
}: ItemGridFilterProps) {
  const { filter } = useItemGridFilterContext();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const hasFiltersApplied = useMemo<boolean>(
    () => !!property && !!filter && property in filter,
    [filter, property],
  );

  return (
    <div className="relative w-full px-2">
      <div className="flex flex-col w-full max-h-96 mt-2 rounded border border-slate-300 border-solid">
        <Button
          active={isOpen || hasFiltersApplied}
          className="item-grid-filter-button flex flex-row justify-start outline-none"
          fill
          intent={hasFiltersApplied ? "warning" : "none"}
          large
          minimal
          onClick={() => setIsOpen(!isOpen)}
          rightIcon={
            <div className="flex flex-row">
              {hasFiltersApplied && (
                <Button
                  className="mr-2 outline-none"
                  icon="reset"
                  intent="warning"
                  onClick={(event) => {
                    event.stopPropagation();
                    onClickFilterReset();
                  }}
                  outlined
                  small
                />
              )}
              <Button
                className="outline-none"
                icon={
                  hasFiltersApplied
                    ? "filter"
                    : isOpen
                      ? "chevron-down"
                      : "chevron-right"
                }
                intent={hasFiltersApplied ? "warning" : "none"}
                minimal
                small
              />
            </div>
          }
          text={text}
        />
        {isOpen && (
          <div className="flex flex-col grow w-full min-h-0 p-2">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
